module.exports = __webpack_public_path__ + "static/media/vivi-repousando-esquerda.b91da53b.svg";